<template>
  <div>
    <div class="columns">
      <div class="column is-3">
        <BContainer background="light" containerClass="is-paddingless">
          <b-menu class="is-paddingless">
            <b-menu-list :label="$t('title.yourReports')">
              <b-menu-item
                icon="check"
                :active="!textReportActive"
                @click="showScoreboardPage('neta')"
              >
                <template slot="label" slot-scope="props">
                  <span>{{ $t('title.netaScore') }}</span>
                  <b-icon
                    class="is-pulled-right"
                    :icon="props.expanded ? 'menu-down' : 'menu-up'"
                  ></b-icon>
                </template>
              </b-menu-item>
              <b-menu-item
                icon="chart-line"
                :label="$t('title.financialReportScore')"
                @click="showScoreboardPage('financialReport')"
              ></b-menu-item>
              <b-menu-item
                icon="gavel"
                :label="$t('title.adaptationScore')"
                @click="showScoreboardPage('adaptation')"
              ></b-menu-item>
              <b-menu-item
                icon="cog"
                :label="$t('title.operationScore')"
                @click="showScoreboardPage('operation')"
              ></b-menu-item>
              <b-menu-item
                icon="search"
                :label="$t('title.abuseScore')"
                @click="showScoreboardPage('abuse')"
              ></b-menu-item>
              <b-menu-item
                icon="recycle"
                :label="$t('title.controlComponents')"
                @click="showComponentPage()"
              ></b-menu-item>
              <b-menu-item
                icon="file-alt"
                :active="isTextReportActive"
                :label="$t('title.internalAuditReport')"
                @click="showTextReport()"
              ></b-menu-item>
            </b-menu-list>
          </b-menu>
        </BContainer>
        <DownloadActionTrackingCalendarButton :answerSetId="data.answerSetId" style="margin-top: 20px; width: 100%;" />
      </div>
      <div class="column is-9">
        <BContainer background="light" containerClass="is-paddingless" v-if="data">
          <ScoreboardPage
            v-if="containerType == 'page'"
            :data="selectedPageData"
            :isComponent="!isNeta"
          />
          <ComponentPage v-else-if="containerType == 'component'" :data="componentData" />
          <div v-else-if="containerType == 'textReport'" v-html="data.textReport"></div>
        </BContainer>
      </div>
    </div>
  </div>
</template>

<script>
import ScoreboardPage from './ScoreboardPage.vue'
import ComponentPage from './ComponentPage.vue'
import DownloadActionTrackingCalendarButton from '@/components/DownloadActionTrackingCalendarButton.vue'

export default {
  props: ['data', 'textReportActive'],
  components: {
    ScoreboardPage,
    ComponentPage,
    DownloadActionTrackingCalendarButton
  },
  data () {
    return {
      isTextReportActive: false,
      selectedPageData: null,
      pagesData: {},
      isNeta: true,
      componentData: null,
      containerType: 'page'
    }
  },
  mounted () {
    this.loadCharData()
    this.isTextReportActive = this.textReportActive
  },
  watch: {
    isTextReportActive: {
      immediate: true,
      handler (newValue) {
        if (newValue) this.showTextReport()
      }
    }
  },
  methods: {
    loadCharData () {
      const totalQuestion = this.data.final.yes + this.data.final.no
      this.pagesData = {
        neta: {
          name: 'Neta',
          ...this.data.final,
          totalQuestion,
          description: `İşletmenizin; hedeflerini yakalamasına, kaynak ve varlıklarını korumasına-etkin kullanmasına,operasyonlarına güvenle devam edebilmesine önemli bir güvence veren iç kontrol mekanizmalarının ${this.data.processName} süreci üzerindeki mevcudiyeti, etkinliği ve güvenilirliğinin genel skorudur.`
        },
        abuse: {
          name: this.$t('title.abuseTitle'),
          ...this.data.abuse,
          totalQuestion,
          description: `${this.data.processName} süreci özelinde muhtemel suiistimalleri önleyici veya tespit edici kontrollerin mevcudiyeti ve etkinliği konusunda hangi seviyede olduğunuzu gösterir.`
        },
        financialReport: {
          name: this.$t('title.financialReportTitle'),
          ...this.data.financialReport,
          totalQuestion,
          description: `Bu skor finansal tablolarınızın ne seviyede güvenilir olduğuna işaret etmektedir. Finansal tablolar işletmenin her sürecinden etkilenir. Bu denetim sonucunda aldığınız skor ise ${this.data.processName} sürecinin finansal tablolara hangi seviyede doğru aktığını ölçmektedir.`
        },
        adaptation: {
          name: this.$t('title.adaptationTitle'),
          ...this.data.adaptation,
          totalQuestion,
          description: `${this.data.processName} süreç işleyişinde muhtemel ve mevcut yasalar, idari düzenlemeler ile hangi seviyede uyumlu olduğunuzu göstermektedir.`
        },
        operation: {
          name: this.$t('title.operationTitle'),
          ...this.data.operation,
          totalQuestion,
          description: `${this.data.processName} süreci özelinde işletme hedeflerine ulaşma, operasyonel mükemmeliyet, verimlilik, performans takibi ve şirket kaynaklarının korunması konularında hangi seviyede olduğunuzu göstermektedir.`
        }
      }
      this.selectedPageData = this.pagesData.neta
    },
    showScoreboardPage (scoreboardName) {
      this.containerType = 'page'
      this.selectedPageData = this.pagesData[scoreboardName]
      if (scoreboardName === 'neta') {
        this.isNeta = true
      } else {
        this.isNeta = false
      }
      this.$emit('showTextReport', false)
    },
    showComponentPage () {
      this.containerType = 'component'
      this.componentData = this.data.components
    },
    showTextReport () {
      this.isTextReportActive = true
      this.containerType = 'textReport'
      this.$emit('showTextReport', true)
    }
  }
}
</script>
<style scoped>
  .menu-label {
    font-size: 15px;
    font-weight: bold;
    color: #000;
  }
</style>
